import { useEditorState } from "@/store";

export function LayoutTest() {
  const { resetLayout } = useEditorState();

  return (
    <div className="w-full h-full flex flex-col">
      <button
        onClick={() => {
          try {
            resetLayout();
          } catch (error) {
            console.error("Invalid JSON format", error);
          }
        }}
      >
        set Layout One
      </button>
    </div>
  );
}
